import { c as _c } from "react/compiler-runtime";
import { Table as ComponentsTable } from '@systemeio/components';
import type { ColumnDefinitionInterface } from '../types/column-interface';
import type { RowsProps } from './view-props';
const getColumnWidth = <T,>(column: ColumnDefinitionInterface<T>, totalWidth: number) => `${(column.widthPercent || 25) / totalWidth * 100}%`;

/**
 * The placeholder both table-shaped views use: a tablet row is composed by its caller, but it
 * follows the same column proportions, so the columns are the only shape worth suggesting.
 */
export function ColumnLoaderRows(t0) {
  const $ = _c(6);
  const {
    limiter,
    visibleColumns,
    totalWidth
  } = t0;
  let t1;
  if ($[0] !== limiter?.limit) {
    t1 = Array.from(Array(Math.min(limiter?.limit || 10, 50)).keys());
    $[0] = limiter?.limit;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== totalWidth || $[4] !== visibleColumns) {
    t2 = <ComponentsTable.Body>{t1.map(index => <ComponentsTable.Row key={index}>{visibleColumns.map((column, columnIndex) => <ComponentsTable.LoaderCell key={`${column.key}-${columnIndex}`} style={{
          width: getColumnWidth(column, totalWidth)
        }} />)}</ComponentsTable.Row>)}</ComponentsTable.Body>;
    $[2] = t1;
    $[3] = totalWidth;
    $[4] = visibleColumns;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}